import DateField from "@/components/DateField/DateField";
import ErrorLabel from "@/components/ErrorLabel/ErrorLabel";
import { formatDate } from "@/utils/misc";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  disabled: boolean;
};

const ReleaseDate = ({ disabled }: Props) => {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();
  const error = getValidationError("releaseDate", activeAsset.id!);
  const isUpdating = isMetadataUpdating(activeAsset.id!, "releaseDate");

  return (
    <>
      <DateField
        id="releaseDate"
        labelText="Release date"
        toolTipText="The release date indicates from what date the asset(s) is approved to be used. Please note that this means that the asset(s) cannot be used with Publicera before the release date has passed.  If the release date has not yet passed a disclaimer will have to be added by the Ingka DAM team to inform the users of this."
        value={formatDate(activeAsset.releaseDate)}
        hasError={Boolean(error)}
        onChange={(value: string | null) =>
          updateMetadata({
            releaseDate: value as string,
          })
        }
        disabled={disabled || isUpdating}
      />
      {Boolean(error) && <ErrorLabel title={error?.message} />}
    </>
  );
};

export default ReleaseDate;
